var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.75C3.30964 2.75 2.75 3.30964 2.75 4V8C2.75 8.41421 2.41421 8.75 2 8.75C1.58579 8.75 1.25 8.41421 1.25 8V4C1.25 2.48122 2.48122 1.25 4 1.25H8C8.41421 1.25 8.75 1.58579 8.75 2C8.75 2.41421 8.41421 2.75 8 2.75H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0286 5.28806C11.6327 4.95248 12.3672 4.95248 12.9712 5.28806L17.4782 7.79195C17.5611 7.83802 17.6399 7.8895 17.7143 7.9458L11.9999 11.1205L6.2855 7.9458C6.35987 7.8895 6.4387 7.83803 6.52163 7.79195L11.0286 5.28806Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 12.4199L18.4834 9.23462C18.4989 9.3349 18.5069 9.43708 18.5069 9.54042V14.4168C18.5069 15.1431 18.1131 15.8123 17.4782 16.1651L12.9712 18.669C12.8991 18.709 12.8252 18.7442 12.7499 18.7747V12.4199Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 18.7747V12.4199L5.51639 9.23462C5.50089 9.3349 5.49292 9.43708 5.49292 9.54042V14.4168C5.49292 15.1431 5.8867 15.8123 6.52164 16.1651L11.0286 18.669C11.1007 18.709 11.1746 18.7442 11.2499 18.7747Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20C2.75 20.6904 3.30964 21.25 4 21.25H8C8.41421 21.25 8.75 21.5858 8.75 22C8.75 22.4142 8.41421 22.75 8 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V16C1.25 15.5858 1.58579 15.25 2 15.25C2.41421 15.25 2.75 15.5858 2.75 16V20Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.75C20.6904 2.75 21.25 3.30964 21.25 4V8C21.25 8.41421 21.5858 8.75 22 8.75C22.4142 8.75 22.75 8.41421 22.75 8V4C22.75 2.48122 21.5188 1.25 20 1.25H16C15.5858 1.25 15.25 1.58579 15.25 2C15.25 2.41421 15.5858 2.75 16 2.75H20Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20C21.25 20.6904 20.6904 21.25 20 21.25H16C15.5858 21.25 15.25 21.5858 15.25 22C15.25 22.4142 15.5858 22.75 16 22.75H20C21.5188 22.75 22.75 21.5188 22.75 20V16C22.75 15.5858 22.4142 15.25 22 15.25C21.5858 15.25 21.25 15.5858 21.25 16V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrDesign);
export default __webpack_public_path__ + "static/media/vr-design.4e2e05a4f6657ab7b5a6c45414e0e8be.svg";
export { ForwardRef as ReactComponent };